import {ValidationError} from "./models/validation-error"
import {ProblemDetails} from "./models/problem-details"

export interface IRegistrationApi {
  registerUser(email: string, password: string, signal?: AbortSignal): Promise<void>
}

export class RegistrationApi implements IRegistrationApi {
  constructor(private baseUrl: string) {
  }

  async registerUser(email: string, password: string, signal?: AbortSignal): Promise<void> {
    const url = this.baseUrl + "/registration/register"
    const signUpUser = {email, password}
    const response = await fetch(url, {method: "post", body: JSON.stringify(signUpUser), headers: {"Content-Type": "application/json"}, signal, credentials: "include"})
    if (response.status === 400) {
      const problemDetails = await response.json() as ProblemDetails
      throw new ValidationError("Validatiefout opgetreden", problemDetails.type)
    }
    if (!response.ok) throw new Error("Error occurred when signing up")
  }
}

export const ValidationErrorPasswordTooShort = "PasswordTooShort"
export const ValidationErrorDuplicateUserName = "DuplicateUserName"

